
import { ApiService } from '../shared/services/api-service/api.service';
import { IAmadeusPaymentMetaDataResponse, IAmadeusPaymentMetaData } from './interfaces/amadeus-payment-configurations.interfaces';


class AmadeusPaymentConfigurationClass {
    async getAmadeusPaymentMetaData(hotelCode: number, payload: IAmadeusPaymentMetaData) {
        try {
            const amadeusPaymentMetaDataResponse: Response = await ApiService.
                getAmadeusPaymentMetaData(hotelCode, payload);
            const amadeusPaymentMetaDataObject: IAmadeusPaymentMetaDataResponse = await amadeusPaymentMetaDataResponse.json();
            return amadeusPaymentMetaDataObject;
        } catch (errorResponse) {
            throw errorResponse;
        }
    }
}

export const AmadeusPaymentConfigurationService = new AmadeusPaymentConfigurationClass();
